// extracted by mini-css-extract-plugin
export default {"code":"code-A1QRX","secondScreen":"secondScreen-l1yMt","joinBtn":"joinBtn-pn2WO"};